import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/refinancia/JC-colombia-horizontal.png'


const _withScopeId = n => (_pushScopeId("data-v-b00a1962"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div style=\"display:flex;align-items:center;flex-direction:column;\" data-v-b00a1962><div class=\"slogan-logos-content__wrap\" data-v-b00a1962><img src=\"" + _imports_0 + "\" alt=\"\" data-v-b00a1962></div></div><div data-v-b00a1962><span class=\"text-2xl font-extrabold color-green md:text-5xl\" data-v-b00a1962> Validacion de QR </span></div><div style=\"margin-bottom:10px;\" data-v-b00a1962><span class=\"text-xl font-extrabold md:text-xl\" data-v-b00a1962> Datos del Documento </span></div>", 3)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Fecha:", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Id:", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Identificación:", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Nombre:", -1))
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Fecha:", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Id:", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Identificación:", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Nombre:", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Vendedor:", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Id Acuerdo:", -1))
const _hoisted_24 = { class: "overflow-x-auto w-full flex justify-center" }
const _hoisted_25 = { class: "table-auto border-collapse border border-gray-300 w-full max-w-4xl text-sm sm:text-base" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-gray-100" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "border border-gray-300 px-4 py-2" }, " No. cuota "),
    /*#__PURE__*/_createElementVNode("th", { class: "border border-gray-300 px-4 py-2" }, " Valor Cuota "),
    /*#__PURE__*/_createElementVNode("th", { class: "border border-gray-300 px-4 py-2" }, "Capital"),
    /*#__PURE__*/_createElementVNode("th", { class: "border border-gray-300 px-4 py-2" }, " Seguro de Vida "),
    /*#__PURE__*/_createElementVNode("th", { class: "border border-gray-300 px-4 py-2" }, " Gastos de cobranza / Honorarios de abogado "),
    /*#__PURE__*/_createElementVNode("th", { class: "border border-gray-300 px-4 py-2" }, " Fecha de pago "),
    /*#__PURE__*/_createElementVNode("th", { class: "border border-gray-300 px-4 py-2" }, " Estado de la cuota ")
  ])
], -1))
const _hoisted_27 = { class: "border border-gray-300 px-4 py-2" }
const _hoisted_28 = { class: "border border-gray-300 px-4 py-2" }
const _hoisted_29 = { class: "border border-gray-300 px-4 py-2" }
const _hoisted_30 = { class: "border border-gray-300 px-4 py-2" }
const _hoisted_31 = { class: "border border-gray-300 px-4 py-2" }
const _hoisted_32 = { class: "border border-gray-300 px-4 py-2" }
const _hoisted_33 = { class: "border border-gray-300 px-4 py-2" }
const _hoisted_34 = { key: 2 }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Fecha:", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Nombre del Banco:", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Identificación:", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Nombre:", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Obligaciones:", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_45 = { class: "overflow-x-auto w-full flex justify-center" }
const _hoisted_46 = { class: "min-w-[700px]" }
const _hoisted_47 = { class: "table-auto border-collapse border border-gray-300 w-full max-w-4xl text-sm sm:text-base" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-gray-100" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "border border-gray-300 px-4 py-2" }, " Producto "),
    /*#__PURE__*/_createElementVNode("th", { class: "border border-gray-300 px-4 py-2" }, " Obligación "),
    /*#__PURE__*/_createElementVNode("th", { class: "border border-gray-300 px-4 py-2" }, " Saldo a Capital "),
    /*#__PURE__*/_createElementVNode("th", { class: "border border-gray-300 px-4 py-2" }, "Otros"),
    /*#__PURE__*/_createElementVNode("th", { class: "border border-gray-300 px-4 py-2" }, " Total intereses "),
    /*#__PURE__*/_createElementVNode("th", { class: "border border-gray-300 px-4 py-2" }, " Total Deuda ")
  ])
], -1))
const _hoisted_49 = { class: "border border-gray-300 px-4 py-2" }
const _hoisted_50 = { class: "border border-gray-300 px-4 py-2" }
const _hoisted_51 = { class: "border border-gray-300 px-4 py-2" }
const _hoisted_52 = { class: "border border-gray-300 px-4 py-2" }
const _hoisted_53 = { class: "border border-gray-300 px-4 py-2" }
const _hoisted_54 = { class: "border border-gray-300 px-4 py-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", null, [
        _createElementVNode("div", null, [
          _createElementVNode("div", null, [
            _hoisted_1,
            (_ctx.dataQr.typeDocument === 'paz-y-salvo')
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _hoisted_5,
                  _createTextVNode(" " + _toDisplayString(_ctx.dataQr ? _ctx.dataQr.fecha : ''), 1),
                  _hoisted_6,
                  _hoisted_7,
                  _createTextVNode(" " + _toDisplayString(_ctx.dataQr ? _ctx.dataQr.id : ''), 1),
                  _hoisted_8,
                  _hoisted_9,
                  _createTextVNode(" " + _toDisplayString(_ctx.dataQr ? _ctx.dataQr.identificacion : ''), 1),
                  _hoisted_10,
                  _hoisted_11,
                  _createTextVNode(" " + _toDisplayString(_ctx.dataQr ? _ctx.dataQr.nombre : ''), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.dataQr.typeDocument === 'refinancia-agreement-status')
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _hoisted_13,
                  _createTextVNode(" " + _toDisplayString(_ctx.dataQr ? _ctx.dataQr.fecha : ''), 1),
                  _hoisted_14,
                  _hoisted_15,
                  _createTextVNode(" " + _toDisplayString(_ctx.dataQr ? _ctx.dataQr.id : ''), 1),
                  _hoisted_16,
                  _hoisted_17,
                  _createTextVNode(" " + _toDisplayString(_ctx.dataQr ? _ctx.dataQr.identificacion : ''), 1),
                  _hoisted_18,
                  _hoisted_19,
                  _createTextVNode(" " + _toDisplayString(_ctx.dataQr ? _ctx.dataQr.nombre : ''), 1),
                  _hoisted_20,
                  _hoisted_21,
                  _createTextVNode(" " + _toDisplayString(_ctx.dataQr ? _ctx.dataQr.Vendedor : ''), 1),
                  _hoisted_22,
                  _hoisted_23,
                  _createTextVNode(" " + _toDisplayString(_ctx.dataQr ? _ctx.dataQr.IDAcuerdo : '') + " ", 1),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("table", _hoisted_25, [
                      _hoisted_26,
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataQr.fees, (data, index) => {
                          return (_openBlock(), _createElementBlock("tr", { key: index }, [
                            _createElementVNode("td", _hoisted_27, _toDisplayString(data.fee_number), 1),
                            _createElementVNode("td", _hoisted_28, _toDisplayString(_ctx.$filters.currency(data.fee_value)), 1),
                            _createElementVNode("td", _hoisted_29, _toDisplayString(_ctx.$filters.currency(data.fee_capital)), 1),
                            _createElementVNode("td", _hoisted_30, _toDisplayString(_ctx.$filters.currency(data.fee_life_insurance)), 1),
                            _createElementVNode("td", _hoisted_31, _toDisplayString(_ctx.$filters.currency(data.fee_outlay_administration)), 1),
                            _createElementVNode("td", _hoisted_32, _toDisplayString(data.fee_date_payment), 1),
                            _createElementVNode("td", _hoisted_33, _toDisplayString(data.fee_state), 1)
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (
                _ctx.dataQr.typeDocument ===
                'refinancia-obligation-without-agreement'
              )
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                  _hoisted_35,
                  _createTextVNode(" " + _toDisplayString(_ctx.dataQr ? _ctx.dataQr.fecha : ''), 1),
                  _hoisted_36,
                  _hoisted_37,
                  _createTextVNode(" " + _toDisplayString(_ctx.dataQr ? _ctx.dataQr.bank_name : ''), 1),
                  _hoisted_38,
                  _hoisted_39,
                  _createTextVNode(" " + _toDisplayString(_ctx.dataQr ? _ctx.dataQr.identificacion : ''), 1),
                  _hoisted_40,
                  _hoisted_41,
                  _createTextVNode(" " + _toDisplayString(_ctx.dataQr ? _ctx.dataQr.nombre : ''), 1),
                  _hoisted_42,
                  _hoisted_43,
                  _createTextVNode(" " + _toDisplayString(_ctx.dataQr ? _ctx.dataQr.business.map((b) => b.credit).join(', ') : ''), 1),
                  _hoisted_44,
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("table", _hoisted_47, [
                        _hoisted_48,
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataQr.business, (data, index) => {
                            return (_openBlock(), _createElementBlock("tr", { key: index }, [
                              _createElementVNode("td", _hoisted_49, _toDisplayString(data.product), 1),
                              _createElementVNode("td", _hoisted_50, _toDisplayString(data.credit), 1),
                              _createElementVNode("td", _hoisted_51, _toDisplayString(_ctx.$filters.currency(data.capital_value)), 1),
                              _createElementVNode("td", _hoisted_52, _toDisplayString(_ctx.$filters.currency(data.others)), 1),
                              _createElementVNode("td", _hoisted_53, _toDisplayString(_ctx.$filters.currency(data.interests)), 1),
                              _createElementVNode("td", _hoisted_54, _toDisplayString(_ctx.$filters.currency(data.current_debt_value)), 1)
                            ]))
                          }), 128))
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}